import { useMemo } from 'react'
import type { Subscription } from '@/lib/subscription'

interface PickerScreenProps {
  subscriptions: Subscription[]
  onPick: (sub: Subscription) => void
}

export function PickerScreen({ subscriptions, onPick }: PickerScreenProps) {
  const sorted = useMemo(
    () => [...subscriptions].sort((a, b) => a.name.localeCompare(b.name)),
    [subscriptions],
  )

  return (
    <div className="flex h-dvh items-center justify-center p-6">
      <div className="w-full max-w-md space-y-4">
        <div className="space-y-1">
          <h1 className="text-base font-medium">Select a subscription</h1>
          <p className="text-sm text-muted-foreground">
            Pick the subscription you want to build links for.
          </p>
        </div>
        <div className="space-y-2">
          {sorted.map((sub) => (
            <button
              key={sub.id}
              type="button"
              onClick={() => onPick(sub)}
              className="block w-full rounded-lg border bg-card px-4 py-3 text-left text-sm font-medium shadow-sm transition-colors hover:bg-muted/50 focus-visible:border-ring focus-visible:ring-3 focus-visible:ring-ring/50 focus-visible:outline-none"
            >
              {sub.name}
            </button>
          ))}
        </div>
      </div>
    </div>
  )
}
